module.exports = __webpack_public_path__ + "img/120.17a9b8c5.jpg";